import { Container } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { RelationsTab } from "../../../companies/relations/RelationsTab";

export const Route = createFileRoute("/firmen/$companyId/mandanten")({
  loader: async ({ params: { companyId }, context: { queryClient, trpc } }) => {
    void queryClient.ensureQueryData(
      trpc.companies.listCompanyRelations.queryOptions({ companyId })
    );
  },
  component: MandantenRoute,
});

function MandantenRoute() {
  const { companyId } = Route.useParams();
  return (
    <Container>
      <RelationsTab companyId={companyId} />
    </Container>
  );
}
